export enum TaskType {
  Task = 'task',
  Group = 'group'
}
